export default __webpack_public_path__ + "static/media/yantramanav.medium.db0d8b7e.ttf";